<script>
import SearchOptions from '../../../advanced/components/search-options'

export default {
  name: 'agendas-search-results-tabs',
  components: {
    SearchOptions
  }
}
</script>

<template lang="pug">
  ul.nav.nav-tabs.nav-515
    SearchOptions
      li.active
        a Resultados da Pesquisa
</template>



// WEBPACK FOOTER //
// src/app/patient/agendas/search/results/components/tabs/tabs.vue